<template>
  <div>
    <slot v-if="hasPermission" />
    <slot name="replacement" v-else></slot>
  </div>
</template>

<script>
export default {
  name: "ComponentGuard",
  props: {
    requiredPermissions: {
      type: Array,
      required: true,
    },
    operator: {
      type: String,
      default: "AND",
    },
  },
  computed: {
    hasPermission() {
      let permissions = localStorage.getItem("roles");
      if (!permissions) {
        return false;
      }
      permissions = JSON.parse(permissions);
      let result = this.operator === "AND" ? true : false;
      for (const requiredPermission of this.requiredPermissions) {
        if (
          this.operator === "AND" &&
          !permissions.includes(requiredPermission)
        ) {
          result = false;
          break;
        }
        if (
          this.operator === "OR" &&
          permissions.includes(requiredPermission)
        ) {
          result = true;
          break;
        }
      }
      return result;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Permissions/ComponentGuard.vue